/**
 *
 *	This service is experimental and still in progress.
 *	@itamarc 8/3/2016
 *
 */

import {Injectable, Inject} from 'ng-metadata/core';
const _forEach = require('lodash/forEach');

var angular:angular.IAngularStatic =  require('angular');
let initInjector:ng.auto.IInjectorService = angular.injector(['ng']);
this.$timeout = initInjector.get<ng.ITimeoutService>('$timeout');


@Injectable()
export class HttpService {

	constructor(@Inject('$http') private $http: ng.IHttpService) {
	}
    
	public call(method: string, url:string, params:Object){
		let httpConfig = {
			method: method,
			url: url,
			params: method === 'GET' ? params : null,
			data: method === 'POST' ? params : null
		};

		return new HttpRequest(httpConfig, this.$http);
	}

    
    /* $http calls in method POST and URL parameters */
    public callPostAndParams(url:string, params:Object, data:Object) {
        return this.call('POST', url+'?'+this.parseObjectToUrlParams(params), data);
    }
    
    private parseObjectToUrlParams(obj) {
        let paramsAsArray = [];
        _forEach(Object.keys(obj), (key)=> {
             paramsAsArray.push(key+'='+obj[key]);
        });
        return paramsAsArray.join('&');  
       
    }

}

class HttpRequest implements ng.IHttpPromise<any>{
	private maxAttempts = 1;
	private attemptsCounter:number = 0;
	//make typescript happy
	public finally;
	public catch;
	public then;

	private $timeout;

	constructor(private httpConfig, private $http) {
		return this.call(httpConfig);
	}

	private call(httpConfig){
 		return this.$http(httpConfig)
			.then(
				(response)=> this.onSuccess(response.data),
				(error)=>this.onFailure(error, httpConfig)
			);
	}

	private onSuccess(response){
		this.attemptsCounter = 0;
		return response;
	}

	private onFailure(reason, httpConfig){
		this.attemptsCounter ++;
		if(this.attemptsCounter < this.maxAttempts ){
			return this.$timeout(() => this.call(httpConfig), 2000);
		} else {
			throw reason;
		}
	}
}

/**
export class StatusMsg {
	public isSuccess:boolean;
	public msg: string;

	constructor(isSuccess:boolean, msg:string){
		this.isSuccess = isSuccess;
		this.msg = msg;
	}
}
*/


// WEBPACK FOOTER //
// ./src/main/webapp/components/infra/httpRequest/http.service.ts